(() => {
  if (window.location.pathname !== '/pages/lickcalm') return;

  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  ready(() => {
    document.querySelectorAll('.shopify-section-group-header-group, .shopify-section-group-footer-group').forEach((section) => {
      section.style.setProperty('display', 'none', 'important');
    });

    if (!document.getElementById('lickcalm-offer-selector-fix')) {
      const style = document.createElement('style');
      style.id = 'lickcalm-offer-selector-fix';
      style.textContent = `
        body:has(.tp-atf) #MainContent { padding-top: 0 !important; }
        .offer-option { cursor: pointer; transition: border-color 160ms ease, background 160ms ease, box-shadow 160ms ease, transform 160ms ease; }
        .offer-option:hover { border-color: rgba(38, 152, 212, 0.55) !important; transform: translateY(-1px); }
        .offer-option.is-selected { border-color: #ff8a3d !important; background: #fff8ef !important; box-shadow: 0 10px 0 #68412d, 0 22px 30px rgba(7, 48, 71, 0.1) !important; }
        .offer-option__check { position: absolute; top: 16px; right: 14px; display: grid; place-items: center; width: 24px; height: 24px; border: 2px solid rgba(49, 83, 102, 0.24); border-radius: 999px; background: #fff; }
        .offer-option__check::after { content: "\\2713"; color: transparent; font-size: 14px; line-height: 1; font-weight: 900; background: transparent; }
        .offer-option.is-selected .offer-option__check { border-color: #2698d4; background: #2698d4; }
        .offer-option.is-selected .offer-option__check::after { color: #fff; }
        .offer-card__bullets li::before { content: "\\2713" !important; }
        html, body { overflow-x: hidden !important; }
        .slow-system__comparison,
        .slow-system__photo,
        .benefits-visual__photo { width: 100% !important; max-width: 100% !important; height: auto !important; max-height: none !important; overflow: hidden !important; }
        .slow-system__comparison { aspect-ratio: 1 / 1.05 !important; }
        .slow-system__photo,
        .benefits-visual__photo { aspect-ratio: 1 / 0.92 !important; }
        .slow-system__comparison img,
        .slow-system__photo img,
        .benefits-visual__photo img { display: block !important; width: 100% !important; height: 100% !important; max-width: none !important; max-height: none !important; object-fit: contain !important; object-position: center !important; aspect-ratio: auto !important; }
        .slow-system__versus { grid-template-columns: repeat(2, minmax(0, 1fr)) !important; }
        .pace-card img { width: 100% !important; height: auto !important; aspect-ratio: 1 / 1 !important; object-fit: contain !important; background: #eef9ff !important; }
        .benefits-visual__grid { align-items: stretch !important; }
        .benefit-tile { display: flex !important; flex-direction: column !important; justify-content: flex-start !important; align-items: center !important; min-height: 0 !important; height: auto !important; }
        .benefit-tile img { width: min(100%, 104px) !important; height: auto !important; aspect-ratio: 1 / 1 !important; object-fit: contain !important; margin: 0 auto 8px !important; }
        @media (max-width: 520px) {
          .slow-system__comparison { aspect-ratio: 1 / 1.05 !important; }
          .slow-system__photo,
          .benefits-visual__photo { aspect-ratio: 1 / 0.92 !important; }
          .benefit-tile img { width: min(100%, 92px) !important; }
        }
      `;
      document.head.appendChild(style);
    }

    const form = document.querySelector('.offer-card__form');
    if (!form) return;

    let quantityInput = form.querySelector('.offer-card__quantity');
    if (!quantityInput) {
      quantityInput = document.createElement('input');
      quantityInput.type = 'hidden';
      quantityInput.name = 'quantity';
      quantityInput.value = '2';
      quantityInput.className = 'offer-card__quantity';
      form.appendChild(quantityInput);
    }

    const options = Array.from(document.querySelectorAll('.offer-option'));
    const quantities = ['2', '1', '3'];

    options.forEach((option, index) => {
      const quantity = quantities[index] || '1';
      option.dataset.offerQuantity = quantity;
      option.setAttribute('role', 'button');
      option.setAttribute('tabindex', '0');
      option.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');

      if (!option.querySelector('.offer-option__check')) {
        const check = document.createElement('span');
        check.className = 'offer-option__check';
        check.setAttribute('aria-hidden', 'true');
        option.appendChild(check);
      }

      const selectOption = () => {
        options.forEach((item) => {
          item.classList.remove('is-selected');
          item.setAttribute('aria-pressed', 'false');
        });

        option.classList.add('is-selected');
        option.setAttribute('aria-pressed', 'true');
        quantityInput.value = quantity;
      };

      option.addEventListener('click', selectOption);
      option.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          selectOption();
        }
      });

      if (index === 0) selectOption();
    });

    form.addEventListener('submit', () => {
      const selected = document.querySelector('.offer-option.is-selected');
      if (selected && selected.dataset.offerQuantity) {
        quantityInput.value = selected.dataset.offerQuantity;
      }
    });
  });
})();
